export const CONFIG_INIT = '@CONFIG/INIT';
export const CONFIG_UPDATE = '@CONFIG/UPDATE';
